<template>
  <transition name="family-sheet-fade">
    <div
      v-if="visible"
      class="family-mobile-confirm"
      :style="{ zIndex: zIndex }"
      @click.self="handleCancel"
    >
      <transition name="family-sheet-slide">
        <div v-if="visible" class="family-mobile-confirm__sheet">
          <h3 v-if="title" class="family-mobile-confirm__title">{{ title }}</h3>
          <p class="family-mobile-confirm__message">{{ message }}</p>
          <div class="family-mobile-confirm__actions">
            <button type="button" class="family-mobile-confirm__btn cancel" @click="handleCancel">
              {{ cancelText }}
            </button>
            <button
              type="button"
              class="family-mobile-confirm__btn confirm"
              :class="{ danger: danger }"
              :disabled="loading"
              @click="handleConfirm"
            >
              {{ loading ? "处理中..." : confirmText }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FamilyMobileConfirm",
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "确定" },
    cancelText: { type: String, default: "取消" },
    danger: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    zIndex: { type: Number, default: 2000 },
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.family-mobile-confirm {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 0 env(safe-area-inset-bottom);
}

.family-mobile-confirm__sheet {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 1.25rem 1.25rem 0 0;
  padding: 1.5rem 1.25rem calc(1.25rem + env(safe-area-inset-bottom));
  box-shadow: 0 -8px 32px rgba(15, 23, 42, 0.12);
}

.family-mobile-confirm__title {
  margin: 0;
  text-align: center;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #0f172a;
}

.family-mobile-confirm__message {
  margin: 0.75rem 0 1.25rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #64748b;
}

.family-mobile-confirm__actions {
  display: flex;
  gap: 0.75rem;
}

.family-mobile-confirm__btn {
  flex: 1;
  height: 3rem;
  border-radius: 0.875rem;
  font-size: 0.9375rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.family-mobile-confirm__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.family-mobile-confirm__btn.cancel {
  background: #f1f5f9;
  color: #475569;
}

.family-mobile-confirm__btn.confirm {
  background: #0082d4;
  color: #fff;
}

.family-mobile-confirm__btn.confirm.danger {
  background: #ef4444;
}

.family-sheet-fade-enter-active,
.family-sheet-fade-leave-active {
  transition: opacity 0.25s ease;
}
.family-sheet-fade-enter,
.family-sheet-fade-leave-to {
  opacity: 0;
}

.family-sheet-slide-enter-active,
.family-sheet-slide-leave-active {
  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);
}
.family-sheet-slide-enter,
.family-sheet-slide-leave-to {
  transform: translateY(100%);
}
</style>
